module.exports = __webpack_public_path__ + "img/809cf1f.png";